import { SmarthopList, adminAnalyticsJobsLogsList } from "@smarthop/list";

function AdminCronJobLogsView(props) {
	const { runId, userId } = props.dataIds;
	return <SmarthopList mode="TABLE" inDialog={true} config={adminAnalyticsJobsLogsList} dataIds={{ userId, runId }} />;
}

export default AdminCronJobLogsView;
